var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuebec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4ea2",
    d: "M0 0h18v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 0h2v12H8zM0 5h18v2H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.15c-.8.5-1.15 1.05-.95 1.55.18.43.6.5.95.2-.12.65.15 1.15.75 1.5.6-.35.87-.85.75-1.5.35.3.77.23.95-.2.2-.5-.15-1.05-.95-1.55-.08.45-.3.75-.75.95-.45-.2-.67-.5-.75-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.15c-.8.5-1.15 1.05-.95 1.55.18.43.6.5.95.2-.12.65.15 1.15.75 1.5.6-.35.87-.85.75-1.5.35.3.77.23.95-.2.2-.5-.15-1.05-.95-1.55-.08.45-.3.75-.75.95-.45-.2-.67-.5-.75-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.6c-.8.5-1.15 1.05-.95 1.55.18.43.6.5.95.2-.12.65.15 1.15.75 1.5.6-.35.87-.85.75-1.5.35.3.77.23.95-.2.2-.5-.15-1.05-.95-1.55-.08.45-.3.75-.75.95-.45-.2-.67-.5-.75-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.6c-.8.5-1.15 1.05-.95 1.55.18.43.6.5.95.2-.12.65.15 1.15.75 1.5.6-.35.87-.85.75-1.5.35.3.77.23.95-.2.2-.5-.15-1.05-.95-1.55-.08.45-.3.75-.75.95-.45-.2-.67-.5-.75-.95z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuebec);
export default __webpack_public_path__ + "static/media/quebec.e92b840d7637c7c1943a9293b50fe15d.svg";
export { ForwardRef as ReactComponent };